module.exports = __webpack_public_path__ + "img/img_login_group.1b2740dc.png";